// Gates the "Get recommendations" entry point. TODO: swap for a LaunchDarkly flag once decided.
export const INTENT_RECOMMENDATIONS_ENABLED: boolean = true;
